/**
 * Single source of truth for Exchanges search-by keys and menu.
 * Used by toolbar, URL parsing, and page hook to avoid drift.
 */

import type { SearchMenuItem } from "../../../components/DataSearchToolbar";

/** Keys used in URL parsing (action → Actions; otherwise first matching key). */
export const EXCHANGES_SEARCH_BY_KEYS = [
  "CustomerPO",
  "PartNumber",
  "AJWSO",
  "CustomerPriority",
  "CompanyName",
  "Actions",
  "CreationDate",
] as const;

/** Search-by menu for the toolbar (value + display label). */
export const EXCHANGES_SEARCH_MENU: SearchMenuItem[] = [
  { value: "CustomerPO", display: "PO No." },
  { value: "PartNumber", display: "Part Number" },
  { value: "AJWSO", display: "AJW SO" },
  { value: "CustomerPriority", display: "Priority" },
  { value: "CompanyName", display: "Company Name" },
  { value: "Actions", display: "Actions" },
];

/** Search-by values that use a text input (debounce). Excludes Actions and CustomerPriority (dropdowns). */
export const EXCHANGES_TEXT_INPUT_SEARCH_BY = EXCHANGES_SEARCH_MENU.filter(
  (m) => m.value !== "Actions" && m.value !== "CustomerPriority",
).map((m) => m.value);
